import { styled } from '@mui/material'

export const Form = styled('form')`
  display: block;
`
